import dayjs from 'dayjs';

import { CaseStudiesCarouselSectionFragment, PageWithModularSectionFragment } from '~/cms';
import { SectionProps } from '~/components/ui';

import { ArticleDataItem, CaseStudyCarouselSectionContent } from './CaseStudiesCarouselContent';

interface CaseStudiesCarouselSectionProps extends CaseStudiesCarouselSectionFragment, SectionProps {
  articleCollection: PageWithModularSectionFragment['articleCollection'];
}

export const CaseStudiesCarouselSection = (props: CaseStudiesCarouselSectionProps) => {
  const {
    articleCollection,
    maxCaseStudies,
    categoryWhitelist,
    categoryBlacklist,
    darkTheme,
    isDark,
    ...otherProps
  } = props;

  // Check if for some reason there are no case studies
  const noCaseStudies =
    !articleCollection || !articleCollection.items || articleCollection.items.length === 0;

  if (noCaseStudies) {
    return <></>;
  }

  let articleDataWithFormattedDates: ArticleDataItem[] = [];
  articleCollection.items.forEach((article) => {
    if (articleDataWithFormattedDates.length < (maxCaseStudies ?? 10)) {
      // If there is a whitelist only include articles from the given categories
      if (
        (categoryWhitelist && categoryWhitelist.includes(`${article.category}`)) ||
        !categoryWhitelist
      ) {
        // If there is a blacklist don't include articles from the given categories
        if (
          (categoryBlacklist && !categoryBlacklist.includes(`${article.category}`)) ||
          !categoryBlacklist
        ) {
          const formattedDate = dayjs(article.date).format('MMM DD, YYYY');
          // const excerpt
          articleDataWithFormattedDates.push({ ...article, formattedDate });
        }
      }
    }
  });

  return (
    <CaseStudyCarouselSectionContent
      isDark={isDark !== undefined ? isDark : darkTheme !== false}
      articleData={articleDataWithFormattedDates}
      {...otherProps}
    />
  );
};
